import './App.css';
import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import {
  SEARCH_SCREEN_PATH,
  LANDING_SCREEN_PATH,
  FINDER_SCREEN_PATH,
  MY_BOOKING_SCREEN_PATH,
  BOOK_SCREEN_PATH,
  TERMS_SCREEN_PATH,
  CONTRACT_CUSTOMER,
  APPLY_CONTRACT_CUSTOMER,
} from './support/routeConstants';
import { Finder } from './features/finder/finder';
import { Landing } from './features/landing/landing';
import { MyBooking } from './features/myBooking/myBooking';
import theme from '../src/theme';
import '../src/theme/style.css';
import { Search } from './features/search/search';
import { Book } from './features/book/book';

import { HelmetProvider } from 'react-helmet-async';
import { Terms } from './features/terms/terms';
import { ContractCustomer } from './features/contractCustomer/contractCustomer';
import { Apply } from './features/apply/apply';
import { AppMetaProvider } from './support/AppMetaProvider';

const App: React.FC = () => {
  return (
    <ChakraProvider theme={theme}>
      <HelmetProvider>
        <AppMetaProvider />
        <BrowserRouter>
          <Routes>
            <Route path={LANDING_SCREEN_PATH} element={<Landing />} />
            <Route path={FINDER_SCREEN_PATH} element={<Finder />} />
            <Route path={SEARCH_SCREEN_PATH} element={<Search />} />
            <Route path={MY_BOOKING_SCREEN_PATH} element={<MyBooking />} />
            <Route path={BOOK_SCREEN_PATH} element={<Book />} />
            <Route path={TERMS_SCREEN_PATH} element={<Terms />} />
            <Route path={CONTRACT_CUSTOMER} element={<ContractCustomer />} />
            <Route path={APPLY_CONTRACT_CUSTOMER} element={<Apply />} />
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </ChakraProvider>
  );
};

export default App;
